<template>
  <div class="layout-content">
    <div :class="headMenuClass">
      <div class="pc-browser">
        <el-menu
        :default-active="activeIndex"
        class="el-menu-demo"
        mode="horizontal"
        @select="handleSelect"
        text-color="#fff"
        active-text-color="#fff">
        <el-menu-item index="Home">首页</el-menu-item>
        <el-menu-item index="Committees">组委会</el-menu-item>
        <el-menu-item index="Program">大会程序</el-menu-item>
        <el-menu-item index="Speaker">特邀报告</el-menu-item>
        <el-menu-item index="Tutorial">TUTORIAL</el-menu-item>
        <el-menu-item index="Workshop">WORKSHOP</el-menu-item>
        <el-menu-item index="APR">APR报告</el-menu-item>
        <el-menu-item index="Posters">POSTER</el-menu-item>
        <el-menu-item index="Register">会议注册</el-menu-item>
        <el-menu-item index="Hotel">交通和酒店</el-menu-item>
        <el-menu-item index="Sponsors">合作单位</el-menu-item>
      </el-menu>
      </div>
      <div class="mobile-browser">
        <div class="mobile-top-contain">
          <div class="mobile-menu-contain">
            <div class="mobile-menu">
              <div class="mobile-menu-grp">
                <span class="web-title" >VALSE 2026 武汉</span>
                <span @click="moreMenuClick" class="more-menu-btn">
                  <div class="more-menu-btn-icon"></div>
                </span>
              </div>
            </div>
            <transition name="el-zoom-in-top">
            <div class="vertical-menu" v-show="verticalMenuShow">
                <el-menu :default-active="activeIndex" class="el-menu-demo" mode="vertical" @select="handleSelect"
                  text-color="white" active-text-color="#b3b3b3" background-color="#0053a1">
                  <el-menu-item index="Home" :route="{ name: 'Home'}">首页</el-menu-item>
                  <el-menu-item index="Committees" :route="{ name: 'Committees'}">组委会</el-menu-item>
                  <el-menu-item index="Program" :route="{ name: 'Program'}">大会程序</el-menu-item>
                  <el-menu-item index="Speaker" :route="{ name: 'Speaker'}">特邀报告</el-menu-item>
                  <el-menu-item index="Tutorial" :route="{ name: 'Tutorial'}">TUTORIAL</el-menu-item>
                  <el-menu-item index="Workshop" :route="{ name: 'Workshop'}">WORKSHOP</el-menu-item>
                  <el-menu-item index="APR" :route="{ name: 'APR'}">APR报告</el-menu-item>
                  <el-menu-item index="Posters" :route="{ name: 'Posters'}">POSTER</el-menu-item>
                  <el-menu-item index="Register" :route="{ name: 'Register'}">会议注册</el-menu-item>
                  <el-menu-item index="Hotel" :route="{ name: 'Hotel'}">交通和酒店</el-menu-item>
                  <el-menu-item index="Sponsors" :route="{ name: 'Sponsors'}">合作单位</el-menu-item>
                </el-menu>
              </div>
            </transition>
          </div>
        </div>
      </div>
    </div>
    <div class="content">
      <router-view/>
    </div>
  </div>

</template>

<script>
    export default {
      name: "TopMenuPageLayout",
      mounted () {
        window.addEventListener('scroll', this.handleScroll,true);
        document.addEventListener('click', (e) => {
          var btn = document.querySelector(".more-menu-btn-icon");
          if(!btn.contains(e.target)){
            this.verticalMenuShow = false
          }
          else{
          }

        })
      },
      created:function(){
        this.activeIndex = this.$route.name;
      },
      data () {
        return {
          activeIndex: 'Committees',
          headMenuClass:"other-menu-content",
          verticalMenuShow: false,
        }
      },
      methods: {
        handleScroll () {
          this.scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
          if(this.scrollTop > 150){
            this.headMenuClass = "other-menu-content not-opacity hor-menubg";
          }
          else{
            this.headMenuClass = "other-menu-content";
          }
        },
        handleSelect (index, indexpath) {
          this.activeIndex = index;
          this.$router.push({ name: index})
        },
        moreMenuClick(){
          this.verticalMenuShow = (this.verticalMenuShow)?false:true;
        }
      }
    }
</script>

<style>

  .layout-content{
    width: 100%;
    height: 100%;
    background-color: white;
  }
  .other-menu-content{
    width: 100%;
    background-color:rgba(82,99,106,0.9);
    color: white;
    text-align: center;
    position: fixed;
    z-index: 2000;
  }
  .not-opacity{
    background-color:rgba(82,99,106);
    border-bottom: 1px solid #e6e6e6;
    /*height: 60px;*/
  }
  .other-menu-content table{
    width: 100%;
    vertical-align: center;
    height: 100%;
  }
  .other-menu-content a{
    color: white;
    padding: 24px 8px;

  }
  .other-menu-content .el-menu-item{
    /*font-size: 18px;*/
  }
  .other-menu-content ul li:hover{
    /*color: red;*/
    cursor: pointer;

  }
  .other-menu-content .el-menu--horizontal .el-menu-item:not(.is-disabled):focus, .el-menu--horizontal .el-menu-item:not(.is-disabled):hover{
    background-color: #0053a1 !important;
  }
  .other-menu-content .el-menu--horizontal>.el-menu-item.is-active{
    border: none;
    background-color: #0053a1 !important;
    font-weight: bolder;
  }
  .other-menu-content .el-menu.el-menu--horizontal{
    border: none;
  }
  .pc-browser .el-menu{

  }
  .pc-browser .el-menu{
    /*width: 960px;*/
    /*margin: 0 auto;*/
    background-color: rgba(82,99,106,0);
    display: flex;
    justify-content: center;
  }


  .page-banner{
    background-repeat: no-repeat;
    background-size:100% 100%;
    -moz-background-size:100% 100%;
  }
  .page-banner p{
    text-align: center;
    padding: 50px 0;
    margin: 0;
    font-size: 36px;
    color: #0053a1;
    font-weight: bolder;
    letter-spacing:4px;
    padding-top: 110px;
  }
  .main-container{
    margin: 50px auto;
    /*margin-top: 50px;*/
    /*margin-bottom: 180px;*/
    width: 60%;
  }
  .content-item{
    margin: 40px auto;
    margin-bottom: 60px;
  }
  .footer{
    width: 100%;
    margin-top: 80px;
  }
  .footer img{
    width: 100%;
  }

  .content-item .item-title{
    text-align: center;
    border-top: 1px solid #0053a1;
    font-size: 24px;
    font-weight: bolder;
  }
  .item-title-content{
    position: relative;
    top:-18px;
    background: #fff;
    display: inline-block;
    color: #0053a1;
    padding: 0 16px;
  }
  .item-content-content{
    padding: 8px 0;
    font-size: 18px;
  }
  .item-content .el-row:hover{
    color: #f27d00;
    cursor: pointer;
  }
  .content-null-info{
    font-size: 16px;
  }
  .item-text-content{
    text-align: justify;
    text-indent: 2em;
    font-size: 18px;
    padding: 8px 16px;
    line-height: 2em;
  }
  .mobile-browser{
    display: none;
  }
  .content ul{
    text-align: left;
  }
  .page-banner-content {
    width: 100%;
    height: 100%;
    background-color: rgba(255,255,255,0.5);
    /*opacity: 0.5;*/
  }
  .page-banner-content p{
    /*color: white;*/
  }
  @media screen and (max-width: 900px){
    .pc-browser{
      display: none;
    }
    .mobile-browser{
      display: inherit;
    }

    .mobile-menu-contain{
      width: 100%;
      /*border-bottom: 1px solid #EBEEF5;*/

    }
    .mobile-menu{
      background-color:rgba(245,245,245,0.7);
      padding: 0;
    }
    .hor-menubg .mobile-menu{
      background-color: #f6faff;
      /*border-bottom: 1px solid #EBEEF5;*/
      border-top: 1px solid #EBEEF5;

    }
    .not-opacity{
      border-bottom: 1px solid #86add2;
    }
    .mobile-menu-grp{
      /*background-image: url("../../static/images/menu_song.png");*/
      background-repeat: no-repeat;
      background-size: contain;
      font-size: 24px;
      padding: 12px 0;
      color: #0053a1;
    }
    .more-menu-btn{
      position: absolute;
      font-size: 38px;
      height: 100%;
      top: 0;
      right: 0;
      width: 40px;
      padding-right: 12px;
    }
    .more-menu-btn .more-menu-btn-icon{
      background-image: url("../../static/images/moremenu_btn.png");
      background-repeat: no-repeat;
      background-size: 30px 20px;
      background-position: center;
      width: 100%;
      height: 100%;
    }
    .web-title{
      text-align: center;
      font-weight: bolder;

    }
    .vertical-menu{
      border-top: 1px solid #0053a1;
      overflow-y: auto;
      top: 59px;
      bottom: 0;
      position: fixed;
      right: 0;
      /*width: 100%;*/
    }
    .vertical-menu .el-menu-item{
      border-bottom: 1px solid white;
      text-align: center;
      margin: 0 8px;
      padding-left: 2px !important;
      padding-right: 2px;
      padding-top: 24px;
    }
    .vertical-menu .el-menu {
      border-right: none;
    }
    .vertical-menu .el-menu-item.is-active{
      background-color: #0053a1 !important;
      font-weight: bolder;

    }
    .vertical-menu .el-menu-item, .el-submenu__title{
      height: 36px;
      line-height: 0;

    }
    .page-banner p{
      text-align: center;
      /*padding: 30px 0;*/
      margin: 0;
      font-size: 26px;
      color: #0053a1;
      font-weight: bolder;
      letter-spacing:1px;
      padding-top: 85px;
    }
    .main-container {
      width: 90%;
    }
    .page-banner{
      background-repeat: no-repeat;
      background-size:cover;
      -moz-background-size:100% 100%;
      height: 150px;
    }
    .item-text-content {
      padding: 4px;
      font-size: 16px;
    }
    .more-menu-btn img{
      padding-bottom: 8px;
      width: 35px;
    }
    .content-item .item-title{
      font-size: 20px;
    }
    .item-title-content{
      top:-14px;
    }
  }
  @media screen and (max-width: 400px){
    .mobile-menu-grp{
      font-size: 24px;
    }
    .more-menu-btn{
      font-size: 32px;
    }
    body{
      background-color: white;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/TopMenuPageLayout.vue